module.exports = __webpack_public_path__ + "static/media/Footer.b59766f7.png";